import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { api } from "helpers/api_url";

export type QuickActionType = 'low_stock' | 'pending_orders' | 'quotation_approval' | 'pending_dispatch';

export interface QuickActionListQuery {
  page: number;
  pageSize: number;
  actionType: QuickActionType;
  dateFrom?: Date;
  dateTo?: Date;
  warehouse?: any[];
  sorting?: any[];
  filters?: any[];
}

// Fetch quick action list (for the table)
export const fetchQuickActionList = createAsyncThunk(
  "quickActions/fetchQuickActionList",
  async (query: QuickActionListQuery, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      console.log("Query in thunk:", query);
      // Pagination
      params.append("page", query.page.toString());
      params.append("page_size", query.pageSize.toString());

      // Date filters
      if (query.dateFrom) {
        params.append("date_from", query.dateFrom.toISOString().split('T')[0]);
      }
      if (query.dateTo) {
        params.append("date_to", query.dateTo.toISOString().split('T')[0]);
      }

      // Warehouse filters
      // if(query.actionType==='low_stock' || query.actionType==='pending_dispatch'){
        if (query.warehouse && query.warehouse.length > 0) {
          const warehouseIds = query.warehouse
            .map((w: any) => w.warehouse_id)
          
          if (warehouseIds.length > 0) {
            if (warehouseIds.length === 1) {
              params.append("warehouse_id", warehouseIds[0].toString());
            } else {
              params.append("warehouse_id", warehouseIds.join(','));
            }
          }
        }
      // }
      console.log("Warehouse IDs:", params.get("warehouse_id"));
      // Sorting
      if (query.sorting && query.sorting.length > 0) {
        const sortField = query.sorting[0].id;
        const sortDirection = query.sorting[0].desc ? '-' : '';
        params.append("ordering", `${sortDirection}${sortField}`);
      }

      // Column filters
      if (Array.isArray(query.filters)) {
        query.filters.forEach((filter: any) => {
          if (filter.filterField && filter.filterValue !== undefined && filter.filterValue !== null) {
            // Handle date range filters
            if (typeof filter.filterValue === "object" && filter.filterValue !== null) {
              const { from_date, to_date } = filter.filterValue;
              if (from_date && (filter.filterField === "created_at" || filter.filterField === "updated_at")) {
                params.append(`${filter.filterField}_from`, from_date);
              }
              if (to_date && (filter.filterField === "created_at" || filter.filterField === "updated_at")) {
                params.append(`${filter.filterField}_to`, to_date);
              }
            } else {
              params.append(filter.filterField, String(filter.filterValue));
            }
          }
        });
      }

      // Select API endpoint based on action type
      
      let url = '';
      switch (query.actionType) {
        case 'low_stock':
          const apiUrl = api?.dashboad?.quick_action_low_stock_list || '';
          url = `${apiUrl}${params.toString() ? `?${params.toString()}` : ''}`;
          break;
        case 'pending_orders':
          const apiUrl2 = api?.dashboad?.quick_action_pending_orders_list || '';
          url = `${apiUrl2}${params.toString() ? `?${params.toString()}` : ''}`;
          break;
        case 'quotation_approval':
          const apiUrl3 = api?.dashboad?.quick_action_quotation_approval_list || '';
          url = `${apiUrl3}${params.toString() ? `?${params.toString()}` : ''}`;
          break;
        case 'pending_dispatch':
          const apiUrl4 = api?.dashboad?.quick_action_pending_dispatch_list || '';
          url = `${apiUrl4}${params.toString() ? `?${params.toString()}` : ''}`;

          break;
        default:
          const apiUrl5 = '';
      }

      const response = await Axios.get(url);

      if (response.data?.data) {
        return {
          data: response.data.data || [],
          totalRecords: response.data.totalRecords || response.data.count || 0,
        };
      }

      return {
        data: [],
        totalRecords: 0,
      };
    } catch (err: any) {
      return rejectWithValue(err?.response?.data || "Network Error");
    }
  }
);

